import React, { useEffect, useState } from 'react';
import { ff } from '@atlassian/jira-feature-flagging';
import { useIntl } from '@atlassian/jira-intl';
import {
	TimeTrackingField as CommonTimeTrackingField,
	FieldContainer,
} from '@atlassian/jira-issue-create-commons';
import { useFormContext } from '@atlassian/jira-issue-create-form-context';
import { secondsToTimeString } from '@atlassian/jira-issue-format-time';

import messages from './messages';
import type { Props } from './types';
import { transformTimeTrackingValueToSubmitFormat, mutateTimeTrackingField } from './utils';

const TimeTrackingField = (props: Props) => {
	// the reason we are transforming the default value here instead of options object in the with form field wrapper is because time tracking settings also need to be passed to transform the default value. Right now, there is no way to pass props to the generic transformDefaultValue invocation in with form field
	const [transformedDefaultValue, setTransformedDefaultValue] = useState<string | undefined>(
		undefined,
	);
	const {
		defaultValue,
		additionalData: { timeTrackingSettings },
		width = 350,
		isMini,
		isFieldResponsive,
	} = props;

	useEffect(() => {
		if (typeof defaultValue === 'string') {
			setTransformedDefaultValue(defaultValue.trim());
		} else if (defaultValue?.timeInSeconds) {
			setTransformedDefaultValue(
				secondsToTimeString(
					timeTrackingSettings.daysPerWeek,
					timeTrackingSettings.hoursPerDay,
				)(defaultValue.timeInSeconds),
			);
		}
	}, [defaultValue, timeTrackingSettings.hoursPerDay, timeTrackingSettings.daysPerWeek]);

	const [, { setTimeTrackingValue }] = useFormContext();
	const { formatMessage } = useIntl();

	const shouldSetWidth = ff('gic-smart-fields-jira-labs_8uwvr')
		? isMini || isFieldResponsive
		: isMini;

	return (
		<FieldContainer width={shouldSetWidth ? '100%' : width}>
			<CommonTimeTrackingField
				{...props}
				fieldName={formatMessage(messages.timeTrackingFieldName)}
				defaultValue={transformedDefaultValue}
				setValueExternal={setTimeTrackingValue}
			/>
		</FieldContainer>
	);
};

export { transformTimeTrackingValueToSubmitFormat, mutateTimeTrackingField };
export default TimeTrackingField;
